import type { PortalActivity, PortalStakeholderLink } from '../types';

export function activityMatchesInvite(
  ev: PortalActivity,
  link: PortalStakeholderLink & { id: string },
): boolean {
  if (ev.source !== 'stakeholder') return false;
  const meta = ev.metadata || {};
  const linkId = typeof meta.stakeholderLinkId === 'string' ? meta.stakeholderLinkId : '';
  if (linkId) return linkId === link.id;
  const name = typeof meta.stakeholderDisplayName === 'string' ? meta.stakeholderDisplayName.trim() : '';
  return !!name && name === link.displayName.trim();
}

export function summarizeInviteActivity(events: PortalActivity[]): {
  eventCount: number;
  lastAt: Date | null;
  lastAction: string | null;
} {
  if (events.length === 0) {
    return { eventCount: 0, lastAt: null, lastAction: null };
  }
  const sorted = [...events].sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime());
  return {
    eventCount: events.length,
    lastAt: sorted[0]?.timestamp || null,
    lastAction: sorted[0]?.action || null,
  };
}

export function formatActivityWhen(date: Date | null): string {
  if (!date) return '—';
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function describeSampleActivityAction(action: string): string {
  switch (action) {
    case 'portal_opened': return 'Opened portal';
    case 'portal_closed': return 'Left portal';
    case 'proposal_opened': return 'Opened proposal';
    case 'proposal_left': return 'Left proposal';
    case 'viewed_proposal': return 'Viewed proposal';
    case 'downloaded_proposal': return 'Downloaded proposal PDF';
    case 'viewed_3d_model': return 'Viewed 3D model';
    case 'viewed_plans': return 'Viewed plans';
    case 'returned_to_portal': return 'Returned to portal';
    default:
      return action.replace(/_/g, ' ');
  }
}
